import { Directive, forwardRef, HostBinding, Inject, InjectionToken, Optional } from '@angular/core';
import { ControlContainer, NgControl, NgForm } from '@angular/forms';

export const FORM_PROVIDER = new InjectionToken('Form provider');

export interface FormProvider {
    getForm(): NgForm;
}

@Directive({
    selector: `
        .form-control[formControl],
        .form-control[formControlName],
        .custom-control-input[formControl],
        .custom-control-input[formControlName],
    `,
})
export class IsInvalidControlDirective {

    @HostBinding('class.is-invalid')
    get isInvalid() {
        const form = this.getForm();
        if (this.control.touched || (form && form.submitted)) {
            return this.control.invalid;
        }
        return false;
    }

    constructor(
        private control: NgControl,
        @Optional() @Inject(FORM_PROVIDER) private formProvider: FormProvider
    ) {}

    private getForm(): NgForm | undefined {
        if (this.formProvider) {
            return this.formProvider.getForm();
        }
    }
}


@Directive({
    selector: `
        .form-group[formGroup],
        .form-group[formGroupName],
    `,
})
export class IsInvalidContainerDirective {

    @HostBinding('class.is-invalid')
    get isInvalid() {
        const form = this.getForm();
        if (this.container.touched || (form && form.submitted)) {
            return this.container.invalid;
        }
        return false;
    }

    constructor(
        private container: ControlContainer,
        @Optional() @Inject(FORM_PROVIDER) private formProvider: FormProvider
    ) {}

    private getForm(): NgForm | undefined {
        if (this.formProvider) {
            return this.formProvider.getForm();
        }
    }
}


@Directive({
    selector: 'form:not([ngNoForm]):not([formGroup]):not([formGroupName])',
    providers: [
        { provide: FORM_PROVIDER, useExisting: forwardRef(() => FormDirective ) },
    ],
})
export class FormDirective implements FormProvider {

    @HostBinding('class.submitted')
    get submitted() {
        return this.ngForm.submitted;
    }

    constructor(private ngForm: NgForm) {}

    getForm() {
        return this.ngForm;
    }
}
